module.exports = __webpack_public_path__ + "img/wine-bottle.4969fb62.svg";